import { ReactNode } from 'react';
import { HiChevronRight } from 'react-icons/hi';

export interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  separator?: ReactNode;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, separator }) => {
  return (
    <nav className="flex gap-2.5 items-center rounded-md">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div key={index} className="flex items-center gap-2.5">
            {item.onClick ? (
              <button
                onClick={item.onClick}
                className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors"
              >
                {item.label}
              </button>
            ) : (
              <span
                className={`text-sm font-medium ${
                  isLast ? 'text-gray-500' : 'text-gray-700'
                }`}
              >
                {item.label}
              </span>
            )}
            {!isLast &&
              (separator || (
                <HiChevronRight className="w-3 h-3 text-gray-400" />
              ))}
          </div>
        );
      })}
    </nav>
  );
};
